import Vue from 'vue'
import Router from 'vue-router'
import goTo from 'vuetify/es5/services/goto'
import * as firebase from "firebase/app";
import "firebase/auth";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    // This is for the scroll top when click on any router link
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0

        if (to.hash) {
            scrollTo = to.hash
        } else if (savedPosition) {
            scrollTo = savedPosition.y
        }

        return goTo(scrollTo)
    },
    // This is for the scroll top when click on any router link
    routes: [
        {
            path: '/',
            redirect: 'authentication/login',
            component: () => import('@/layouts/full-layout/Layout'),
            children: [
                // Application
                // Components
                {
                    name: 'Programs',
                    path:'/programs',
                    component: () => import('@/views/Programs.vue'),
                    meta: {requiresAuth: true}
                },
                {
                    name: 'Submission',
                    path: '/submission',
                    component: () => import('@/views/Submissions.vue'),
                },
                {
                    name: 'Users',
                    path:'/users',
                    component: () => import('@/views/Users.vue'),
                    meta: {requiresAuth: true}
                },
                {
                    name: 'ContactList',
                    path: 'apps/contact-list',
                    component: () => import('@/views/apps/contact-list/ContactList'),
                    meta: {requiresAuth: true}
                },
                {
                    name: 'TableDatatable',
                    path: 'tables/TableDatatable',
                    component: () => import('@/views/tables/table-data-table/TableDatatable'),
                    meta: {requiresAuth: true}
                },
                {
                    name: 'ApexCharts',
                    path: 'charts/apexcharts',
                    component: () => import('@/views/charts/apexcharts/ApexCharts'),
                    meta: {requiresAuth: true}
                },
                {
                    name: 'Classic',
                    path: 'dashboard',
                    component: () => import('@/views/dashboards/classic/Classic'),
                    meta: {requiresAuth: true}
                },
                {
                    name: 'LGA',
                    path: 'dashboard/lga',
                    component: () => import('@/views/dashboards/classic/Classic'),
                    meta: {requiresAuth: true}
                },
                {
                    name: 'Quicklinks',
                    path: 'quicklinks',
                    component: () => import('@/views/dashboards/classic/Quicklinks'),
                    meta: {requiresAuth: true}
                },
                {
                    name: 'OnDemand',
                    path: 'ondemand',
                    component: () => import('@/views/dashboards/classic/OnDemand'),
                    meta: {requiresAuth: true}
                }
            ]
        },
        
        {
            path: '/authentication',
            component: () => import('@/layouts/blank-layout/Blanklayout'),
            children: [
                {
                    name: 'BoxedLogin',
                    path: 'login',
                    component: () => import('@/views/authentication/BoxedLogin'),
                },
                {
                    name: 'Submission',
                    path: 'submission',
                    component: () => import('@/views/Submissions.vue'),
                },
                {
                    name: 'Wexer Signup',
                    path: 'wexer',
                    component: () => import('@/views/WexerSignUp.vue'),
                    meta: {requiresAuth: false}
                },
                {
                    name: 'Error',
                    path: 'error',
                    component: () => import('@/views/authentication/Error'),
                },
            ]
        },
        {
            name: 'Wexer Signup',
            path: 'wexer',
            component: () => import('@/views/WexerSignUp.vue'),
            meta: {requiresAuth: false}
        },
        {
            path: '*',
            component: () => import('@/views/authentication/Error'),
        }
    ],
})
  
router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const isAuthenticated = firebase.auth().currentUser;
    console.log("isauthenticated", isAuthenticated);
    if (requiresAuth && !isAuthenticated) {
      to("/authentication/Login");
    } else {
      next();
    }
  });

export default router;